class APIS {
	apis() {
		return {
			// Connects a new web-chat domain (a client can have multiple, like Facebook
			// pages) - used by the "Add a new domain" wizard on /channels/WebChat.
			accountCreate: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/web/accounts/create'
			},
			// Re-checks the verification meta tag for one domain (body: {accountId}).
			accountVerify: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/web/accounts/verify'
			},
			// Fetches a single web-chat domain by id (body: {accountId}).
			accountGet: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/web/accounts/get'
			},
			// Fetches all of the client's connected web-chat domains - used to render
			// /channels/WebChat and to gate/populate the Web tab everywhere else.
			accountGetAll: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/web/accounts/get-all'
			},
			// Soft-disconnects one web-chat domain (body: {accountId}).
			accountDisconnect: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/web/accounts/disconnect'
			},
			// Saves widget branding (color/position/welcome message/header title) and
			// the session-window-minutes reply-window duration for one domain
			// (body: {accountId, configuration, sessionWindowMinutes}).
			accountBranding: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/web/accounts/branding'
			},
			// Returns the embeddable <script> snippet for one domain (body: {accountId}).
			accountSnippet: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/web/accounts/snippet'
			},
			// Pings the widget so it shows an "agent is typing…" indicator to the
			// visitor. Fire-and-forget, throttled from the composer while the agent
			// types (body: {accountId, customerId} - same ids used for /web/messages/read).
			messagesTyping: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/web/messages/typing'
			}
		};
	}
}

export default new APIS();
